import React from 'react';
import { Configurator } from './pages/Configurator';
interface AppProps {
  /** Which negotiation stance the configurator opens on. */
  startingPreset?: 'snakker' | 'security' | 'balanced' | 'hunter' | 'owner';
}
export function App({
  startingPreset = 'snakker'
}: AppProps) {
  return <Configurator initialPreset={startingPreset} data-id="element-0" data-mp="3farf5rmivu4m" />;
}